import { useState, useEffect, useRef } from "react";
import "./Footer.css";
import { portalLink } from "../utils/portal";

function Footer() {
  const [activeTab, setActiveTab] = useState("company");

  // ── Mobile Login dialog (same as Header) ──
  const [loginOpen, setLoginOpen] = useState(false);
  const [learningOpen, setLearningOpen] = useState(false);
  const [comingSoon, setComingSoon] = useState(null);

  const openComingSoon = (event, type) => {
    event.preventDefault();
    const label = type === "trainer" ? "Trainer" : "Student";
    setLoginOpen(false);
    setComingSoon({
      title: `${label} Portal`,
      text: `Our ${label.toLowerCase()} portal service will be launching soon. Stay tuned!`,
    });
  };

  // ── Mobile Login / Register floating bar ──
  // Shows while scrolling down, hides while scrolling up (mobile only via CSS)
  const [showAuthBar, setShowAuthBar] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    lastScrollY.current = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY.current && currentScrollY > 80) {
        // scrolling down
        setShowAuthBar(true);
      } else if (currentScrollY < lastScrollY.current) {
        // scrolling up
        setShowAuthBar(false);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* Mobile-only floating Login / Register bar */}
      <div
        className={`mobile-auth-bar ${showAuthBar ? "is-visible" : ""}`}
        role="navigation"
        aria-label="Login and Register"
      >
        <button
          type="button"
          className="mobile-auth-btn mobile-auth-btn--login"
          onClick={() => setLoginOpen(true)}
        >
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
              stroke="currentColor"
              strokeWidth="1.8"
            />
            <path
              d="M4 20c1.4-3.6 4.6-5.5 8-5.5s6.6 1.9 8 5.5"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
          </svg>
          Login
        </button>
        <a
          href={portalLink("/student-register")}
          className="mobile-auth-btn mobile-auth-btn--register"
        >
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
              stroke="currentColor"
              strokeWidth="1.8"
            />
            <path
              d="M1.5 20c1.3-3.6 4.3-5.5 7.5-5.5"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
            <path
              d="M18 8v6M15 11h6"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
          </svg>
          Register
        </a>
      </div>

      <footer className="main-footer-wrapper">
      <div className="ipdi-footer">
        <div className="footer-top">

          {/* Contact */}
          <section className="footer-contact" aria-label="Contact IPDI">
            <h3>Not sure if IPDI is right for you?</h3>
            <p>Get in Touch with us for Details</p>
            <p className="email-id-p">info@ipdi.co.in</p>
            <p>For Queries and assistance</p>
            <div className="footer-phone-links">
              <a className="footer-button" href="tel:+919156031516">
                91-9156-031-516
              </a>
              <a className="footer-button" href="tel:+919158941222">
                +91-9158-941-222
              </a>
            </div>
          </section>

          {/* Programs / Company / Admissions — becomes tabs on mobile only */}
          <div className="footer-tabs-wrapper">

            {/* Mobile-only tab nav (hidden on desktop/tablet via CSS) */}
            <div className="footer-tabs-nav" role="tablist" aria-label="Footer sections">

            <button
                type="button"
                role="tab"
                aria-selected={activeTab === "company"}
                className={`footer-tab-btn ${activeTab === "company" ? "active" : ""}`}
                onClick={() => setActiveTab("company")}
              >
                Company
              </button>

              <button
                type="button"
                role="tab"
                aria-selected={activeTab === "programs"}
                className={`footer-tab-btn ${activeTab === "programs" ? "active" : ""}`}
                onClick={() => setActiveTab("programs")}
              >
                Programs
              </button>
              
              <button
                type="button"
                role="tab"
                aria-selected={activeTab === "admissions"}
                className={`footer-tab-btn ${activeTab === "admissions" ? "active" : ""}`}
                onClick={() => setActiveTab("admissions")}
              >
                Job Portal
              </button>
            </div>


 {/* Company */}
            <section
              className={`footer-column footer-tab-panel ${activeTab === "company" ? "is-active" : ""}`}
              aria-label="Company"
            >
              <h3>Company</h3>
              <ul className="footer-links">
                {/* <li><a href="/#about">About IPDI</a></li> */}
                <li><a href="/hire">Hire Talent</a></li>
                <li><a href="/jobs">Jobs</a></li>
                 <li><a href="/#trainers">Our Trainers</a></li>
                 
                   <li><a href="/contactus">Contact Us</a></li>
                    {/* <li><a href="/enroll">Enroll Now</a></li> */}
                <li className="footer-enroll-item">
      <a href="/enroll"  style={{ color: "#c84b20" }} >Enroll Now</a>
    </li>
              
                {/* <li><a href="/blog">Blog</a></li> */}
              </ul>
            </section>


            {/* Programs */}
            <section
              className={`footer-column footer-tab-panel ${activeTab === "programs" ? "is-active" : ""}`}
              aria-label="Programs"
            >
              <h3>Programs</h3>
              <ul className="footer-links">
                <li><a href="/course-executive-architect">Executive Architect</a></li>
                <li><a href="/course-executive-interior">Executive Interior Designer</a></li>
                 <li><a href="/customise-your-program">Customized your Own Program</a></li>
                {/* <li><a href="/urban-landscape">Urban &amp; Landscape Design</a></li>
                <li><a href="/all-courses">All Courses</a></li> */}

              </ul>
            </section>

           

            {/* Admissions */}
            <section
              className={`footer-column footer-tab-panel ${activeTab === "admissions" ? "is-active" : ""}`}
              aria-label="Admissions"
            >
              <h3>Job Portal</h3>
              <ul className="footer-links">
                  <li><a href={portalLink("/company-register")}>Company Registration</a></li>
                <li><a href={portalLink("/company-login")}>Company Login</a></li>
                <li><a href={portalLink("/student-register")}>Student Registration</a></li>
                <li><a href={portalLink("/student-login")}>Student Login</a></li>
                <li><a href={portalLink("/college-register")}>college Registration</a></li>
                  <li><a href={portalLink("/college-login")}>college Login</a></li>
              
              </ul>
            </section>

          </div>

          {/* Follow Us */}
          <section className="footer-follow" aria-label="Follow IPDI">
            <h3>Follow us</h3>
            <ul className="footer-social-links">
              <li>
                <a
                  href="https://www.facebook.com/ipdindia/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="IPDI on Facebook"
                >
                  <img src="/assets/img/facebook.svg" alt="" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/institute-of-planners-and-designers-india/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="IPDI on LinkedIn"
                >
                  <img src="/assets/img/linked.svg" alt="" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/ipdindia/?hl=en"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="IPDI on Instagram"
                >
                  <img src="/assets/img/insta.svg" alt="" />
                </a>
              </li>
              {/* <li>
                <a
                  href="https://www.youtube.com/channel/UC_1ejP0iFmPNxKGwrQUbiEw"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="IPDI on YouTube"
                >
                  <img src="/assets/img/youtube.svg" alt="" />
                </a>
              </li> */}
            </ul>
          </section>

        </div>

        <div className="footer-bottom">
          <ul className="privacy-cookie">
            <li>
              <a
                href="/assets/legal/terms-and-conditions.pdf"
                target="_blank"
                rel="noreferrer"
              >
                Privacy
              </a>
            </li>
            <li>
              <a href={portalLink("/help-center-student")}>Help</a>
            </li>
            <li>
              <a
                href="/assets/legal/terms-and-conditions.pdf"
                target="_blank"
                rel="noreferrer"
              >
                Cookies Policy
              </a>
            </li>
            <li>
              <a href="/credits">Credits</a>
            </li>
          </ul>
          <p className="all-rights-reserved">
            {"\u00A9"} 2026 Institute of Planners and Designers India Pvt.Ltd.
            All rights reserved.
          </p>
        </div>
      </div>
      </footer>

      {/* ── Mobile login dialog (same as Header) ── */}
      {loginOpen && (
        <div className="mobile-login-backdrop" onClick={() => setLoginOpen(false)}>
          <div
            className="mobile-login-dialog"
            onClick={(event) => event.stopPropagation()}
          >
            <ul className="mobile-login-menu">
              <li>
                <a href={portalLink("/company-login")}>Employer</a>
              </li>
              <li>
                <a href={portalLink("/student-login")}>Job seeker</a>
              </li>
              <li>
                <a href={portalLink("/college-login")}>College</a>
              </li>
              <li className="learning-parent">
                <button
                  type="button"
                  onClick={() => setLearningOpen((open) => !open)}
                >
                  Learning Portal
                </button>
                {learningOpen && (
                  <ul className="learning-submenu">
                    <li>
                      <a
                        href={portalLink("portal/student-portal")}
                        onClick={(event) => openComingSoon(event, "student")}
                      >
                        Student
                      </a>
                    </li>
                    <li>
                      <a
                        href={portalLink("portal/trainer-portal")}
                        onClick={(event) => openComingSoon(event, "trainer")}
                      >
                        Trainer
                      </a>
                    </li>
                  </ul>
                )}
              </li>
            </ul>
          </div>
        </div>
      )}

      {/* ── Coming soon dialog ── */}
      {comingSoon && (
        <div
          className="mobile-login-backdrop"
          onClick={() => setComingSoon(null)}
        >
          <div
            className="coming-soon-dialog"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="coming-soon-close"
              onClick={() => setComingSoon(null)}
              aria-label="Close"
            >
              ×
            </button>
            <h2>{comingSoon.title}</h2>
            <p>{comingSoon.text}</p>
          </div>
        </div>
      )}
    </>
  );
}

export default Footer;